import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const TriangleUpIcon = createIcon(
  'TriangleUp',
  // @todo replace with path
  <polygon points="12 18 20 6 4 6"/>
);

TriangleUpIcon.warning = true;

export default TriangleUpIcon;
